import { Banner, Text, useThemeColor, Link, Icon } from '@wistia/vhs';
import styled from 'styled-components';
import type { JSX } from 'react';

const StyledChildren = styled.div`
  margin-bottom: 8px;
`;

const BannerMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
`;

const IconWrapper = styled.span`
  margin-right: 8px;
`;

const StyledBanner = styled(Banner)`
  padding: 12px;
  align-items: center;
`;

const StyledLink = styled(Link)`
  /* override VHS link styles */
  &:nth-child(n) {
    color: ${({ theme }) => theme.color.grey900};
  }
`;

export const CommentingHasMovedBanner = ({
  children = undefined,
}: {
  children?: JSX.Element | JSX.Element[];
}): JSX.Element => {
  const grey200 = useThemeColor('grey200');

  return (
    <StyledBanner backgroundColor={grey200}>
      <Banner.Body>
        {children ? <StyledChildren>{children}</StyledChildren> : null}
        <BannerMessageWrapper>
          <IconWrapper>
            <Icon
              type="info"
              size="md"
            />
          </IconWrapper>
          <Text variant="body2">
            Public team commenting is now{' '}
            <span style={{ fontWeight: '500' }}>Share for review</span>. Find it under{' '}
            <span style={{ fontWeight: '500' }}>Share</span>.{' '}
            <StyledLink href="https://support.wistia.com/en/articles/8380934-commenting">
              Learn more
            </StyledLink>
          </Text>
        </BannerMessageWrapper>
      </Banner.Body>
    </StyledBanner>
  );
};
